let elToEmphasizeEl = document.querySelector('#hero-text-to-emphasize')
let toEmphasize = elToEmphasizeEl ? elToEmphasizeEl.innerText : ''
const heroTextDisplay = document.getElementById('hero-text')
const scrollForMoreText = document.getElementById('scroll-text')
let finalText = heroTextDisplay && heroTextDisplay.innerHTML
for (let emphasize of toEmphasize.split('\n')) {
	finalText =
		emphasize.length > 0
			? finalText.replaceAll(
					new RegExp(emphasize, 'g'),
					`<span class="text-primary">${emphasize}</span>`,
			  )
			: finalText
}
if (heroTextDisplay) heroTextDisplay.innerHTML = finalText

const astronountImg = document.getElementById('astronount-image')
const earthImg = document.getElementById('earth-image')

let currentAstroZoom = 1
let currentEarthZoom = 1
let currentHeroDisplay = 1
let currentScrollForMore = 1
let currScrollPos = 0
function getNums(str) {
	let matches = str.match(/(\d+)/)

	if (matches && matches.length > 0)
		return str[matches.index - 1] === '-' ? -1 * +matches[0] : +matches[0]
	return 0
}

function zoomImage(
	element,
	direction,
	currentZoom,
	stepSize,
	minZoom,
	maxZoom,
	top = false,
	scale = true,
) {
	if (!element) return
	let newZoom = currentZoom + direction * stepSize
	let currTop = getNums(
		window.getComputedStyle(element).getPropertyValue('top'),
	)
	if (newZoom < minZoom || newZoom > maxZoom) {
		return currentZoom
	}

	currentZoom = newZoom

	// Update the CSS transform of the element to scale it
	if (scale) element.style.transform = `scale(${currentZoom})`
	if (top)
		element.style.top = direction > 0 ? `${currTop + 2}px` : `${currTop - 2}px`
	return currentZoom
}

window.addEventListener('scroll', function (ev) {
	const dir = window.pageYOffset > currScrollPos ? 1 : -1
	currentAstroZoom = zoomImage(
		astronountImg,
		dir,
		currentAstroZoom,
		0.005,
		1,
		2.5,
	)
	currentHeroDisplay = zoomImage(
		heroTextDisplay,
		dir,
		currentHeroDisplay,
		0.005,
		1,
		1.1,
		false,
	)
	currentEarthZoom = zoomImage(
		earthImg,
		-1 * dir,
		currentEarthZoom,
		0.005,
		0.75,
		1.25,
	)
	currentScrollForMore = zoomImage(
		scrollForMoreText,
		-1 * dir,
		currentScrollForMore,
		0.005,
		0.5,
		1,
		false,
	)
	currScrollPos = window.pageYOffset
})

export default {
	toEmphasize: toEmphasize,
	heroTextDisplay: heroTextDisplay,
	scrollForMoreText: scrollForMoreText,
	astronountImg: astronountImg,
	earthImg: earthImg,
	window: window,
}
